import { Controller } from "@hotwired/stimulus"

// Подтверждение при редактировании заказа: если тип доставки меняется с
// «Доставка» на «Самовывоз», связанная заявка на доставку будет удалена —
// спрашиваем подтверждение перед сохранением.
export default class extends Controller {
  static targets = ["deliveryType"]
  static values = { originalDeliveryType: String }

  confirmSubmit(event) {
    if (!this.hasDeliveryTypeTarget) return

    const changedToPickup =
      this.originalDeliveryTypeValue === "delivery" &&
      this.deliveryTypeTarget.value === "pickup"

    if (!changedToPickup) return

    const ok = window.confirm(
      "Тип изменён на «Самовывоз». Заявка на доставку по этому заказу будет удалена. Подтвердить?"
    )
    if (!ok) event.preventDefault()
  }
}
